import { FC } from "react";
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { FormProps } from "@dashboard/modules/products/types/product-form.types";
import { getProfessionalsFromToppings } from "@dashboard/modules/products/utils/service-form.utils";
import { ServiceProfessionalsCardWrapper } from "./service-professionals-card.styled";

const ServiceProfessionalsCard: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { values } = useFormikContext<FormProps>();
  const professionals = getProfessionalsFromToppings(values.toppings).filter(
    (p) => p.enabled && p.value.trim().length > 0
  );

  const handleEdit = () => {
    navigate("professionals");
  };

  return (
    <ServiceProfessionalsCardWrapper>
      <div className="professionals-header">
        <span className="professionals-title">
          {t("productComponent.service.professionals.title")}
        </span>
        <button type="button" className="edit-button" onClick={handleEdit}>
          {professionals.length > 0
            ? t("productComponent.service.professionals.edit")
            : t("productComponent.service.professionals.add")}
        </button>
      </div>

      {professionals.length > 0 ? (
        <div className="professionals-list">
          {professionals.map((professional) => (
            <span
              key={professional.value}
              className="professional-chip"
            >
              {professional.value}
            </span>
          ))}
        </div>
      ) : (
        <p className="professionals-empty">
          {t("productComponent.service.professionals.empty")}
        </p>
      )}
    </ServiceProfessionalsCardWrapper>
  );
};

export default ServiceProfessionalsCard;
